var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canPublish(_vm.account, _vm.schoolList))?_c('BaseFlow',{attrs:{"type":"success","icon":"ni ni-check-bold"},on:{"click":_vm.publish}},[_vm._v(" Publier la liste ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }